import React, { useState } from "react";
import { useSchoolLanguageOptional } from "../../contexts/SchoolLanguageContext";
import { LanguageSwitcher } from "./LanguageSwitcher";
import type { AppLang } from "../../i18n";

/**
 * Portal header language control (Student / Teacher / Parent / School Admin).
 * Hidden on DevTeam (no SchoolLanguageProvider) and when fewer than 2 allowed languages.
 */
export const HeaderLanguageSelector: React.FC = () => {
  const schoolLang = useSchoolLanguageOptional();
  const [busy, setBusy] = useState(false);

  if (!schoolLang) return null;

  const allowed = schoolLang.allowedLanguages;
  const current = schoolLang.language ?? ("en" as AppLang);

  if (allowed.length < 2) return null;

  const onLanguageChange = async (lng: AppLang) => {
    if (lng === current || busy) return;
    setBusy(true);
    try {
      await schoolLang.setUserLanguage(lng);
    } finally {
      setBusy(false);
    }
  };

  return (
    <LanguageSwitcher
      allowedLanguages={allowed}
      currentLanguage={current}
      onLanguageChange={onLanguageChange}
      disabled={busy}
    />
  );
};
